import React, {createRef, useEffect} from 'react';
import PropTypes from "prop-types";
import Pikaday from "pikaday";
import moment from "moment";

import {DEFAULT_DATE_FORMAT} from '../../../constants/dates';

import './date_picker.scss';

const uniq_id = 'datepicker-field-' + Date.now() + '-' + Math.floor(Math.random() * 100);
let pikaday = undefined;

const DatePicker = function (
    {
        date,
        onChange,
        minDate,
        maxDate,
        numberOfMonths = 1,
        events = [],
        with_reset = false
    }
) {
    const field = createRef();

    useEffect(() => {
        pikaday = new Pikaday({
            field: field.current,
            format: DEFAULT_DATE_FORMAT,
            onSelect: function () {
                onChange(this.getMoment());
            },
            numberOfMonths: numberOfMonths,
            events: events.map(day => new Date(day * 1000).toDateString()),
            minDate: minDate,
            maxDate: maxDate
        });

        return () => pikaday.destroy();
    }, []);
    useEffect(() => {
        if (minDate) {
            pikaday.setMinDate(minDate);
        }
    }, [minDate]);
    useEffect(() => {
        if (maxDate) {
            pikaday.setMaxDate(maxDate);
        }
    }, [maxDate]);

    function renderReset() {
        if (with_reset && date) {
            return (
                <i
                    className='datepicker-reset fas fa-times-circle'
                    onClick={() => {
                        onChange(null);
                        field.current.value = '';
                    }}
                />
            );
        }

        return null;
    }

    return (
        <div className='picker-block'>
            <input
                ref={field}
                type="text"
                className="date-picker-input"
                id={uniq_id}
                placeholder="Pick a date"
                defaultValue={date ? moment(date).format(DEFAULT_DATE_FORMAT) : ''}
            />
            <i className="far fa-calendar-alt calendar-icon"/>
            {renderReset()}
        </div>
    );
}

DatePicker.propTypes = {
    date: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    numberOfMonths: PropTypes.number,
    events: PropTypes.arrayOf(PropTypes.number),
    minDate: PropTypes.object,
    maxDate: PropTypes.object,
    with_reset: PropTypes.bool
};

export default DatePicker;
